<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :keyStatus="filterProps.status"
      :keyType="filterProps.type"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :keyStatus="filterProps.status"
        :keyType="filterProps.type"
        @clearKey="clearKey"
        @addNew="addNew"
      />
      <router-view
        v-if="isSysRights('SupplierMallHelp.findBySupplier')"
        :first_loading="firstLoading"
        :items="items"
        @deleteAD="deleteAD"
        @editAD="editAD"
        @move="move"
      ></router-view>
      <no-rights v-else></no-rights>
      <pagination
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/mall-help/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
      <api-loading :show="loading"></api-loading>
      <Modal
        :modalId="'modalNewAD'"
        :home="false"
        :loading="modalNewAD.loading"
        :size="'lg'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("mall.添加内容") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <form>
              <div class="form-group row mg-b-10">
                <label
                  class="col-md-3 col-form-label form-control-sm text-right"
                >
                  {{ $t("mall.类型") }}<span class="tx-danger">*</span>：
                </label>
                <div
                  class="
                    col-md-8 col-sm-12
                    d-flex
                    align-items-center
                    pd-0
                    mg-l-10
                  "
                >
                  <select
                    class="form-control form-control-sm"
                    v-model="modalNewAD.type"
                  >
                    <option value="">{{ $t("mall.类型") }}</option>
                    <option
                      v-for="(s, k) in $dict.helpType"
                      :key="k"
                      :value="k"
                    >
                      {{ $t(s) }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group row mg-b-10">
                <label
                  class="col-md-3 col-form-label form-control-sm text-right"
                >
                  {{ $t("mall.标题") }}<span class="tx-danger">*</span>：
                </label>
                <div
                  class="
                    col-md-8 col-sm-12
                    d-flex
                    align-items-center
                    pd-0
                    mg-l-10
                  "
                >
                  <input
                    v-model="modalNewAD.title"
                    type="text"
                    :placeholder="$t('mall.请输入标题')"
                    class="form-control form-control-sm"
                  />
                </div>
              </div>
              <div class="form-group row mg-b-10">
                <label
                  class="col-md-3 col-form-label form-control-sm text-right"
                >
                  {{ $t("mall.内容：") }}
                </label>
                <div
                  class="
                    col-md-8 col-sm-12
                    d-flex
                    align-items-center
                    pd-0
                    mg-l-10
                  "
                >
                  <textarea
                    id="proDescription"
                    class="xheditor"
                    rows="5"
                    name="proDescription"
                    v-model="modalNewAD.content"
                    style="width: 100%"
                    :placeholder="$t('mall.请输入内容')"
                  ></textarea>
                </div>
              </div>
              <div class="form-group row mg-b-10">
                <label
                  class="col-md-3 col-form-label form-control-sm text-right"
                >
                  {{ $t("mall.状态：") }}
                </label>
                <div
                  class="
                    col-md-8 col-sm-12
                    d-flex
                    align-items-center
                    pd-0
                    mg-l-10
                  "
                >
                  <select
                    class="form-control form-control-sm"
                    v-model="modalNewAD.status"
                  >
                    <option value="">{{ $t("mall.状态") }}</option>
                    <option
                      v-for="(s, k) in $dict.helpStatus"
                      :key="k"
                      :value="k"
                    >
                      {{ $t(s) }}
                    </option>
                  </select>
                </div>
              </div>
            </form>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-15
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="saveNewAD()"
              >
                {{ $t("mall.确定") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("mall.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <confirmComponent
        @del_index_i="deletesFn"
        :modal_id="delAddr.modalId"
        :modal_title="delAddr.title"
        :modal_text="delAddr.text"
        :del_index="delAddr.delIndex"
      ></confirmComponent>
    </div>
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; //$t('mall.左边栏')
import Header from "./header.vue"; //$t('mall.头')
import Modal from "@components/Modal";
import { pagination } from "@components/pagination.js"; //$t('mall.分页')
import { innerPagination } from "@components/pagination.js"; //$t('mall.分页')
import { confirmComponent } from "@components/components.js"; //$t('mall.$t('mall.删除')确认')
export default {
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //$t('mall.左边栏')$t('mall.状态')
      firstLoading: true,
      loading: false,
      page: this.$route.params.page ? this.$route.params.page : 1,
      totalPage: 1,
      rowsPerPage: parseInt(store.get("mall-marketing-rowsPerPage"))
        ? parseInt(store.get("mall-marketing-rowsPerPage"))
        : 10,
      pageSizeSelect: [10, 20, 50],
      totalCount: 0,
      items: [],
      filterProps: {
        status: "",
        type: "",
        clickType: "",
      },
      modalNewAD: {
        loading: false,
        status: "",
        type: "",
        id: "",
        title: "",
        content: "",
      },
      modalNewADDefault: "{}",
      delAddr: {
        modalId: "modalDelAD",
        title: this.$t("mall.删除"),
        text: this.$t("mall.确定要删除吗"),
        delIndex: "",
      },
    };
  },
  components: {
    LeftSide,
    Header,
    Modal,
    pagination,
    confirmComponent,
    innerPagination,
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("mall-help-rowsPerPage", this.rowsPerPage);
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.getItems();
    this.modalNewADDefault = JSON.stringify(this.modalNewAD);
  },
  updated() {},
  methods: {
    editAD(item) {
      this.modalNewAD.id = item.id;
      this.modalNewAD.status = item.status;
      this.modalNewAD.type = item.type;
      this.modalNewAD.title = item.title;
      this.modalNewAD.content = item.content;
      $("#proDescription").xheditor({
        tools: `Cut,Copy,Paste,Pastetext,|,Source,Fullscreen,Img,Blocktag,Fontface,FontSize,Bold,Italic,Underline,Strikethrough,FontColor,BackColor,Align,List,Link,Unlink,Anchor,Hr,Table`,
        upImgUrl:
          "//" +
          (window.location.host.toLowerCase().indexOf("sandbox") >= 0
            ? "sandboxapi."
            : "api.") +
          "5yoho.cn/upload.php ",
        width: 560,
      });
      $("#proDescription").val(this.modalNewAD.content);
      $("#modalNewAD").modal("show");
    },
    updateItems(id) {
      this.loading = true;
      $.api_call(
        "api.SupplierMallHelp.findBySupplier",
        {
          id: id,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            if (r.Data.Results.length == 0) return;
            this.items.forEach((e, i) => {
              if (e.id == r.Data.Results[0].id) {
                this.items.splice(i, 1, r.Data.Results[0]);
              }
            });
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    deletesFn() {
      //$t('mall.删除')
      this.loading = true;
      $.api_call(
        "api.SupplierMallHelp.deleteBySupplier",
        {
          id: this.delAddr.delIndex,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems();
            $(`#${this.delAddr.modalId}`).modal("hide");
            ShowTip(this.$t("mall.删除成功"), "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    deleteAD(item) {
      this.delAddr.delIndex = item.id;
      $("#" + this.delAddr.modalId).modal("show");
    },
    saveNewAD() {
      if (!this.modalNewAD.status) {
        ShowTip(this.$t("mall.请选择状态"), "danger");
        return;
      }
      this.modalNewAD.loading = true;
      let params = {
        type: this.modalNewAD.type,
        status: this.modalNewAD.status,
        title: this.modalNewAD.title,
        content: $("#proDescription").val(),
      };
      let url = !this.modalNewAD.id
        ? "api.SupplierMallHelp.addBySupplier"
        : "api.SupplierMallHelp.changeBySupplier";
      let tx = !this.modalNewAD.id
        ? this.$t("mall.添加成功")
        : this.$t("mall.修改成功");
      if (this.modalNewAD.id) {
        params.id = this.modalNewAD.id;
      }
      $.api_call(url, params, (r) => {
        this.modalNewAD.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(tx, "success");
          $("#modalNewAD").modal("hide");
          if (this.modalNewAD.id) {
            this.updateItems(this.modalNewAD.id);
            return;
          }
          this.getItems();
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    addNew() {
      //$t('mall.打开添加修改')
      this.modalNewAD = JSON.parse(this.modalNewADDefault);
      $("#modalNewAD").modal("show");
      $("#proDescription").xheditor({
        tools: `Cut,Copy,Paste,Pastetext,|,Source,Fullscreen,Img,Blocktag,Fontface,FontSize,Bold,Italic,Underline,Strikethrough,FontColor,BackColor,Align,List,Link,Unlink,Anchor,Hr,Table`,
        upImgUrl:
          "//" +
          (window.location.host.toLowerCase().indexOf("sandbox") >= 0
            ? "sandboxapi."
            : "api.") +
          "5yoho.cn/upload.php ",
        width: 560,
      });
      $("#proDescription").val("");
    },
    getItems() {
      if (!this.isSysRights("SupplierMallHelp.findBySupplier")) return;
      this.loading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        status: this.filterProps.status,
        type: this.filterProps.type,
      };
      $.api_call("api.SupplierMallHelp.findBySupplier", params, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.firstLoading = false;
          this.items = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
          $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    move(item, type) {
      //$t('mall.上移下移')
      let tx = type == 1 ? this.$t("mall.上移成功") : this.$t("mall.下移成功");
      this.loading = true;
      $.api_call(
        "api.SupplierMallHelp.moveBySupplier",
        {
          id: item.id,
          type: type,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems();
            ShowTip(tx, "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    clearKey(type) {
      this.filterProps[type] = "";
      this.toPage(1);
    },
    filtrate(status, type) {
      (this.filterProps = {
        status,
        type,
      }),
        this.toPage(1);
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ path: "/mall-help/" + 1 });
      if (page == 1) {
        this.getItems();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({ path: "/mall-help/" + num });
      if (page == num) {
        this.getItems();
      }
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getItems();
    },
  },
};
</script>

<style lang="less" scoped>
.body-inner {
  [data-id="datepicker-from"],
  [data-id="datepicker-to"] {
    background-color: #fff;
    border-color: rgba(0, 0, 0, 0.15);
    color: #495057;
  }
  ul {
    padding: 0;
    list-style: none;
    margin-bottom: 0;
  }
}
.nav.nav-outline {
  padding: 0 15px;
}
</style>